<template>
  <div class="header box-shadow">
    <div class="row-1">
      <div class="uk-container large uk-text-right uk-padding-remove">
        <img class="flag" src="../assets/flags/nl.png" @click="$store.commit('setFlag', 'nl')" />
        <!-- <img class="flag" src="../assets/flags/eng.png"
        @click="$store.commit('setFlag', 'eng')"
        style="cursor: default" />-->
      </div>
    </div>

    <div class="uk-container large uk-hidden@l header-small">
      <div class="uk-flex uk-flex-between small">
        <span
          @click="toggleOffcanvas()"
          uk-toggle="target: #offcanvas"
          class="material-icons icon"
        >menu</span>
        <div class="uk-flex">
          <img src="../assets/png/dnz-projects.png" class="logo" />
          <div class="logo-texts-small">
            <span>
              {{logoTitle[this.$store.state.selectedLang][0]}}
              <br />
              {{logoTitle[this.$store.state.selectedLang][1]}}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="uk-container large uk-visible@l header-large">
      <div class="uk-flex uk-flex-between uk-align-center uk-padding">
        <div class="uk-flex">
          <img src="../assets/png/dnz-projects.png" class="logo" />
          <span class="logo-text">
            {{logoTitle[this.$store.state.selectedLang][0]}}
            <br />
            {{logoTitle[this.$store.state.selectedLang][1]}}
          </span>
        </div>
        <div class="uk-flex uk-flex-middle">
          <router-link class="link"
          :class="{'active': thisRoute == 'home'}" to="/">home</router-link>
          <router-link
            class="link"
            :class="{'active': thisRoute == 'services'}"
            to="/services"
          >diensten</router-link>
          <router-link
            class="link"
            :class="{'active': thisRoute == 'vacancies'}"
            to="/vacancies"
          >vacatures</router-link>
          <router-link class="link"
          :class="{'active': thisRoute == 'about'}" to="/about">over ons</router-link>
          <router-link
            class="link"
            :class="{'active': thisRoute == 'contact'}"
            to="/contact"
          >contact</router-link>
        </div>
      </div>
    </div>
    <Offcanvas />
  </div>
</template>

<script>
import Offcanvas from './Offcanvas.vue';
import { logoTitle } from '../text';

export default {
  components: {
    Offcanvas,
  },
  computed: {
    logoTitle() {
      return logoTitle;
    },
    thisRoute() {
      return this.$route.name;
    },
  },
  methods: {
    toggleOffcanvas() {},
  },
};
</script>

<style lang="less" scoped>
@import "../assets/vars.less";
.header {
  margin-bottom: 5rem;
}
.box-shadow {
  -webkit-box-shadow: 3px 6px 134px -5px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 3px 6px 134px -5px rgba(0, 0, 0, 0.1);
  box-shadow: 3px 6px 134px -5px rgba(0, 0, 0, 0.1);
}

.row-1 {
  // padding: 0.5rem 0;
  // margin: .5rem;
  padding: 0.3rem;
  background: @primary-background-color;
  // background: white;
  // border-bottom: 1px solid @border-color;
  color: rgb(165, 165, 165);
  // padding-right: 10rem;

  .flag {
    width: 1.8rem;
    margin: 0 1rem;
    cursor: pointer;
  }
}

.header-small {
  padding: 1rem 1rem;
  max-width: 100rem;
  .logo {
    display: block;
    max-width: 100px;
    max-height: 45px;
    width: auto;
    height: auto;
  }

  .icon {
    color: @primary-color;
    font-size: 2rem;
    padding-top: 0.6rem;
  }
}

.logo-texts-small {
  font-family: "Taviraj", serif;
  padding-left: 0.4rem;
  padding-top: 0rem;
  font-size: 0.9rem;
  text-align: left;
  // line-height: 1;
  color: rgb(168, 168, 168);
}

.header-large {
  padding: 0 3rem;
  max-width: 100rem;
  .logo {
    width: 128px;
    height: 52px;
  }
  .logo-text {
    font-family: "Taviraj", serif;
    margin-left: 0.5rem;
    font-size: 1.5rem;
    line-height: 1;
    color: rgb(168, 168, 168);
  }
}

.link {
  color: @primary-color;
  margin-left: 3rem;
  font-family: "Space Mono";
  font-size: 1.3rem;
  text-transform: uppercase;
  &:hover {
    text-decoration: none;
    color: @primary-color-hover;
  }
  &.active {
    color: @primary-color-active;
    cursor: default;
  }
}
</style>
